<template>
  <div class="dynamic-tables">
    <h2 class="page-title">Permohonan Nonberusaha Swasta</h2>
    <Widget customHeader>
      <div v-if="user.role === 'admin_kkp'">
        <DataAdmin ref="childAdmin" :baseapi="baseapi" :dataPermohonan="dataPermohonan" :user="user" :tipe="'Swasta'"
          @loadProgress="loadProgress" />
      </div>
      <div v-if="user.role === 'admin_upt'">
        <DataAdminUPT ref="childAdmin" :baseapi="baseapi" :user="user" :tipe="'Swasta'" @loadProgress="loadProgress" />
      </div>
      <div v-if="user.role === 'pic'">
        <DataPIC ref="childAdmin" :baseapi="baseapi" :dataPermohonan="dataPermohonan" :user="user" :tipe="'Swasta'"
          @loadProgress="loadProgress" @checkStatusBayar="checkStatusBayar"/>
      </div>
      <div v-if="user.role === 'pic_upt'">
        <DataPICUPT ref="childAdmin" :baseapi="baseapi" :dataPermohonan="dataPermohonan" :user="user" :tipe="'Swasta'"
          @loadProgress="loadProgress" />
      </div>
      <div v-if="user.role === 'pic_monitor'">
        <DataPICMonitoring ref="childAdmin" :baseapi="baseapi" :dataPermohonan="dataPermohonan" :user="user"
          :tipe="'Swasta'" @loadProgress="loadProgress" @checkStatusBayar="checkStatusBayar"/>
      </div>
      <div v-if="user.role === 'bendahara'">
        <DataBendahara ref="childBendahara" :baseapi="baseapi" :dataPermohonan="dataPermohonan" :user="user"
          @verifPembayaran="verifPembayaran" :tipe="'Swasta'" @loadProgress="loadProgress" @checkStatusBayar="checkStatusBayar"/>
      </div>
      <div v-if="user.role === 'tim_teknis'">
        <DataTimTeknis ref="childAdmin" :baseapi="baseapi" :dataPermohonan="dataPermohonan" :user="user"
          @verifPembayaran="verifPembayaran" :tipe="'Swasta'" @loadProgress="loadProgress" />
      </div>
      <div v-if="user.role === 'ptsa' || user.role === 'tim_penilai_pusat' || user.role === 'tim_penilai_upt'">
        <DataPTSA ref="childAdmin" :baseapi="baseapi" :dataPermohonan="dataPermohonan" :user="user"
          @verifPembayaran="verifPembayaran" :tipe="'Swasta'" @loadProgress="loadProgress" />
      </div>
      <div v-if="user.role === 'tim_teknis_pemutakhiran'">
        <DataTimTeknisPemutakhiran ref="childAdmin" :baseapi="baseapi" :user="user" :tipe="'Swasta'" />
      </div>

      <div v-if="user.role === 'superuser'">
        <DataSuperuser ref="childAdmin" :baseapi="baseapi" :dataPermohonan="dataPermohonan" :user="user"
          @verifPembayaran="verifPembayaran" :tipe="'Swasta'" @loadProgress="loadProgress"
          @deleteDokumen='deleteDokumen' />
      </div>
      <div>

      </div>
    </Widget>

    <b-modal body-class="bg-white" id="modal-pembayaran" :title="'Buat Tagihan Billing PNBP (' + (
  dataPerDokumen.file_tagihan_i === null &&
  dataPerDokumen.file_tagihan_ii === null &&
  dataPerDokumen.file_tagihan_iii === null
    ? 'Tagihan 1)'
    : dataPerDokumen.file_tagihan_i !== null &&
      dataPerDokumen.file_tagihan_ii === null &&
      dataPerDokumen.file_tagihan_iii === null
    ? 'Tagihan 2)'
    : 'Tagihan 3)'
)" cancel-title="Close" ok-title="Accept"
      cancel-variant="outline-secondary">
      <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-tagihan">
        <strong>Detail Tagihan</strong>
        <b-row class="mt-2">
          <b-col md="12">
            <b-form-group label="Jenis Permohonan" label-for="form">
              <v-select id="default-select" disabled v-model="dataPerDokumen.jenis_pnbp" :options="[
                'Area',
                'Kabel Bawah Laut',
                'Pipa Air Bersih / Air Baku',
                'Pipa Selain Air Bersih / Air Baku',
              ]" name="Jenis Permohonan" :class="{ 'is-invalid': errors.has('form-1.Jenis Permohonan') }"
                :multiple="true" :close-on-select="false" />
            </b-form-group>
          </b-col>
          <b-col md="12" v-if="dataPerDokumen?.jenis_pnbp?.includes('Area')">
            <b-form-group label="Luas (ha)" label-for="form">
              <b-form-input disabled min="0" step=".01" type="number" name="Luas" :class="{
                'form-control': true,
                'is-invalid': errors.has('form-1.Luas'),
              }" v-model="dataPerDokumen.luas" />

            </b-form-group>
          </b-col>

          <b-col md="12" v-if="
            dataPerDokumen?.jenis_pnbp?.includes('Kabel Bawah Laut')
          ">
            <b-form-group label="Panjang Kabel(di dalam Kws. Konservasi)(km)" label-for="form">
              <b-form-input disabled min="0" step=".01" type="number" name="Panjang Kabel(di dalam Kws. Konservasi)(km)"
                :class="{
                  'form-control': true,
                  'is-invalid': errors.has(
                    'form-1.Panjang Kabel(di dalam Kws. Konservasi)(km)'
                  ),
                }" v-model="dataPerDokumen.panjang_konservasi_kabel" />

            </b-form-group>
          </b-col>
          <b-col md="12" v-if="
            dataPerDokumen?.jenis_pnbp?.includes('Kabel Bawah Laut')
          ">
            <b-form-group label="Panjang Kabel(di luar Kws. Konservasi)(km)" label-for="form">
              <b-form-input disabled min="0" step=".01" type="number" name="Panjang Kabel(di luar Kws. Konservasi)(km)"
                :class="{
                  'form-control': true,
                  'is-invalid': errors.has('form-1.Panjang Kabel(di luar Kws. Konservasi)(km)'),
                }" v-model="dataPerDokumen.panjang_nonkonservasi_kabel" />

            </b-form-group>
          </b-col>

          <b-col md="12" v-if="
            dataPerDokumen?.jenis_pnbp?.includes('Pipa Air Bersih / Air Baku')
          ">
            <b-form-group label="Panjang Pipa Air Bersih(di dalam Kws. Konservasi)(km)" label-for="form">
              <b-form-input disabled min="0" step=".01" type="number"
                name="Panjang Pipa Air Bersih(di dalam Kws. Konservasi)(km)" :class="{
                  'form-control': true,
                  'is-invalid': errors.has(
                    'form-1.Panjang Pipa Air Bersih(di dalam Kws. Konservasi)(km)'
                  ),
                }" v-model="dataPerDokumen.panjang_konservasi_pipa_air" />

            </b-form-group>
          </b-col>
          <b-col md="12" v-if="
            dataPerDokumen?.jenis_pnbp?.includes('Pipa Air Bersih / Air Baku')
          ">
            <b-form-group label="Panjang Pipa Air Bersih(di luar Kws. Konservasi)(km)" label-for="form">
              <b-form-input disabled min="0" step=".01" type="number"
                name="Panjang Pipa Air Bersih(di luar Kws. Konservasi)(km)" :class="{
                  'form-control': true,
                  'is-invalid': errors.has('form-1.Panjang Pipa Air Bersih(di luar Kws. Konservasi)(km)'),
                }" v-model="dataPerDokumen.panjang_nonkonservasi_pipa_air" />

            </b-form-group>
          </b-col>

          <b-col md="12" v-if="
            dataPerDokumen?.jenis_pnbp?.includes('Pipa Selain Air Bersih / Air Baku')
          ">
            <b-form-group label="Panjang Pipa Selain Air Bersih(di dalam Kws. Konservasi)(km)" label-for="form">
              <b-form-input disabled min="0" step=".01" type="number"
                name="Panjang Pipa Selain Air Bersih(di dalam Kws. Konservasi)(km)" :class="{
                  'form-control': true,
                  'is-invalid': errors.has(
                    'form-1.Panjang Pipa Selain Air Bersih(di dalam Kws. Konservasi)(km)'
                  ),
                }" v-model="dataPerDokumen.panjang_konservasi_pipa_lain" />
            </b-form-group>
          </b-col>
          <b-col md="12" v-if="
            dataPerDokumen?.jenis_pnbp?.includes('Pipa Selain Air Bersih / Air Baku')
          ">
            <b-form-group label="Panjang Pipa Selain Air Bersih(di luar Kws. Konservasi)(km)" label-for="form">
              <b-form-input disabled min="0" step=".01" type="number"
                name="Panjang Pipa Selain Air Bersih(di luar Kws. Konservasi)(km)" :class="{
                  'form-control': true,
                  'is-invalid': errors.has('form-1.Panjang Pipa Selain Air Bersih(di luar Kws. Konservasi)(km)'),
                }" v-model="dataPerDokumen.panjang_nonkonservasi_pipa_lain" />

            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group label="Jumlah PNBP" label-for="form">
              <currency-input disabled v-model="dataPerDokumen.potensi_pnbp" :class="{
                'form-control': true,
                'is-invalid': errors.has('form-1.Jumlah PNBP'),
              }" v-validate="'required'" name="Jumlah PNBP" :currency="{
                prefix: 'Rp ',
                thousandsSeparator: '.',
                decimalSeparator: ',',
                precision: 0,
              }" />
            </b-form-group>
          </b-col>
        </b-row>
        <!-- <span v-if="
          dataPerDokumen.file_tagihan_i === null &&
          dataPerDokumen.file_tagihan_ii === null &&
          dataPerDokumen.file_tagihan_iii === null
        ">
          <strong>Tagihan 1</strong>
          <b-row class="mt-2">
            <b-col md="12">
              <b-form-group label="Tanggal Tagihan: *" label-for="username">
                <input type="date" v-model="dataPerDokumen.tanggal_tagihan_i" v-validate="'required'"
                  name="Tanggal Tagihan" :class="{
                    'form-control': true,
                    'is-invalid': errors.has('form-tagihan.Tanggal Tagihan'),
                  }" />
                <span class="text-danger" v-if="errors.has('form-tagihan.Tanggal Tagihan')">
                  {{ errors.first("form-tagihan.Tanggal Tagihan") }}
                </span>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group label="File Tagihan: *" label-for="username">
                <b-form-file placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." plain
                  class="form-control" v-model="dataPerDokumen.tagihan_i" accept=".pdf"></b-form-file>
              </b-form-group>
              
            </b-col>
          </b-row>
        </span>
        <span v-else-if="
          dataPerDokumen.file_tagihan_i !== null &&
          dataPerDokumen.file_tagihan_ii === null &&
          dataPerDokumen.file_tagihan_iii === null
        ">
          <strong>Tagihan 2</strong>
          <b-row class="mt-2">
            <b-col md="12">
              <b-form-group label="Tanggal Tagihan: *" label-for="username">
                <input type="date" v-model="dataPerDokumen.tanggal_tagihan_ii" v-validate="'required'"
                  name="Tanggal Tagihan" :class="{
                    'form-control': true,
                    'is-invalid': errors.has('form-tagihan.Tanggal Tagihan'),
                  }" />
                <span class="text-danger" v-if="errors.has('form-tagihan.Tanggal Tagihan')">
                  {{ errors.first("form-tagihan.Tanggal Tagihan") }}
                </span>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group label="File Tagihan: *" label-for="username">
                <b-form-file placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." plain
                  class="form-control" v-model="dataPerDokumen.tagihan_ii" accept=".pdf"></b-form-file>
              </b-form-group>
              
            </b-col>
          </b-row>
        </span>
        <span v-else>
          <strong>Tagihan 3</strong>
          <b-row class="mt-2">
            <b-col md="12">
              <b-form-group label="Tanggal Tagihan: *" label-for="username">
                <input type="date" v-model="dataPerDokumen.tanggal_tagihan_iii" v-validate="'required'"
                  name="Tanggal Tagihan" :class="{
                    'form-control': true,
                    'is-invalid': errors.has('form-tagihan.Tanggal Tagihan'),
                  }" />
                <span class="text-danger" v-if="errors.has('form-tagihan.Tanggal Tagihan')">
                  {{ errors.first("form-tagihan.Tanggal Tagihan") }}
                </span>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group label="File Tagihan: *" label-for="username">
                <b-form-file placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." plain
                  class="form-control" v-model="dataPerDokumen.tagihan_iii" accept=".pdf"></b-form-file>
              </b-form-group>
            </b-col>
          </b-row>
        </span> -->
      </form>

      <div class="alert alert-info d-flex align-items-center" role="alert">
        <i class="bi bi-info-circle-fill me-2"></i>
        <div>
          Billing berlaku selama <strong>7 hari</strong> sejak tanggal pembuatan tagihan.
        </div>
      </div>


      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float:right" @click="onSubmitPembayaran">
            <i class="fa fa-file-text-o text-white" />

            <span class="text-white"> Generate Tagihan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <ModalTracking v-model="showModalTracking" :progressPermohonan="progressPermohonan"/>
  </div>

</template>

<style>
table.table.b-table>thead>tr>th[aria-sort="ascending"]::after,
table.table.b-table>tfoot>tr>th[aria-sort="ascending"]::after {
  opacity: 1;
  content: "\2191";
}

.dt-button.btn.btn-primary {
  border: none;
}

.dt-button.btn.btn-primary:hover {
  background-color: #35a0fd !important;
  border: none;
}
</style>

<script>
import Widget from "@/components/Widget/Widget";
import Swal from "sweetalert2";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import vSelect from "vue-select";
import axios from "axios";
import VueLoading from "vuejs-loading-plugin";
import Vue from "vue";
import moment from "moment";
import { formatDate } from "../../../helper/helpernew";
import DataAdmin from "./DataDokumen/Admin"
import DataAdminUPT from "./DataDokumen/AdminUPT"
import DataPIC from "./DataDokumen/PIC"
import DataPICUPT from "./DataDokumen/PICUPT"
import DataPICMonitoring from "./DataDokumen/PICMonitor"
import DataBendahara from "./DataDokumen/Bendahara"
import DataTimTeknis from "./DataDokumen/TimTeknis"
import DataPTSA from "./DataDokumen/PTSA"
import DataSuperuser from "./DataDokumen/Superuser"
import DataTimTeknisPemutakhiran from "./DataDokumen/TimTeknisPemutakhiran"
import CurrencyInput from "../../../components/CurrencyInput/CurrencyInput.vue";
import ModalTracking from "../Components/ModalTracking.vue";
import toast from "../../../helper/toast.js";

// using default options
Vue.use(VueLoading);

// overwrite defaults
Vue.use(VueLoading, {
  dark: true, // default false
  text: "Loading", // default 'Loading'
  loading: true, // default false
  //customLoader: myVueComponent, // replaces the spinner and text with your own
  background: "rgb(255,255,255)", // set custom background
  classes: ["myclass"], // array, object or string
});

export default {
  name: "Dynamic",
  components: { Widget, ClassicEditor, vSelect, DataAdmin, DataPIC, DataBendahara, DataAdminUPT, DataPICUPT, DataPICMonitoring, DataTimTeknis, DataPTSA, DataSuperuser, DataTimTeknisPemutakhiran,CurrencyInput, ModalTracking },
  data() {
    return {
      baseapi: localStorage.getItem("baseapi"),
      user: JSON.parse(localStorage.getItem("user")),
      dataPermohonan: [],
      progressPermohonan: [],
      popoverShow: {},
      dataPerDokumen: [],
      showModalTracking: false
    };
  },

  mounted() {
    // localStorage.setItem('tipe_pemohon','Pemerintah')
    // if(this.user.role == 'superuser'){
    //   this.loaddata();
    // }
  },
  methods: {
    onClose(id) {
      this.popoverShow[id] = false;
    },
    format_date(val, format) {
      if (val) return formatDate(val, format);
    },
    loaddata() {
      axios
        .get(
          this.baseapi +
          "api/permohonan_nonberusaha?filter=tipe_pemohon,=,Swasta",
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.dataPermohonan = response.data.data;
          console.log(this.dataPermohonan);
          this.initDatatable();
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },
    async deletePermohonan(id) {
      Swal.fire({
        title: "Apa kamu yakin?",
        text: "Anda tidak akan dapat mengembalikan data ini!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya, hapus",
        cancelButtonText: "Tutup",
      }).then(async (result) => {
        if (result.isConfirmed) {
          axios
            .delete(this.baseapi + "api/permohonan_nonberusaha/" + id, {
              headers: {
                Authorization: `Bearer ` + this.user.accessToken,
              },
            })
            .then((response) => {
              Swal.fire("Berhasil", "" + response.data.message + "", "success");
              $("#example").DataTable().destroy();
              this.loaddata();
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    edit(id) {
      localStorage.setItem("id_permohonan", id);
      localStorage.setItem("tipe_pemohon", "Pemerintah");
      this.$router.push("/app/permohonan/form");
    },

    verifPembayaran(id) {
      axios.get(this.baseapi + "api/permohonan_nonberusaha/" + id, {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataPerDokumen = response.data.data;
        this.dataPerDokumen['tagihan_i'] = this.dataPerDokumen.file_tagihan_i
        this.dataPerDokumen['tagihan_ii'] = this.dataPerDokumen.file_tagihan_ii
        this.dataPerDokumen['tagihan_iii'] = this.dataPerDokumen.file_tagihan_iii
        console.log(this.dataPerDokumen)
        Swal.fire({
          title: 'Buat Tagihan',
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya'
        }).then((result) => {
          if (result.isConfirmed) {
            this.$bvModal.show('modal-pembayaran')
          }
        })
      }).catch(error => {
        console.log(error)
        return error
      });
    },

    // upload pembayaran
    onSubmitPembayaran() {
      this.$validator.validateAll("form-tagihan").then((result) => {
        if (result) {

          this.$nextTick(() => {
            this.$bvModal.hide('modal-pembayaran')
          });
          this.$loading(true);
          let formData = new FormData();
          // if (this.dataPerDokumen.tanggal_tagihan_ii === null && this.dataPerDokumen.tanggal_tagihan_iii === null) {
          //   // formData.append('file_tagihan_i', this.dataPerDokumen.tagihan_i);
          //   formData.append('tanggal_tagihan_i', this.dataPerDokumen.tanggal_tagihan_i);
          // } else if (this.dataPerDokumen.tanggal_tagihan_iii === null) {
          //   // formData.append('file_tagihan_i', this.dataPerDokumen.tagihan_i);
          //   formData.append('tanggal_tagihan_i', this.dataPerDokumen.tanggal_tagihan_i);
          //   // formData.append('file_tagihan_ii', this.dataPerDokumen.tagihan_ii);
          //   formData.append('tanggal_tagihan_ii', this.dataPerDokumen.tanggal_tagihan_ii);
          // } else {
          //   // formData.append('file_tagihan_i', this.dataPerDokumen.tagihan_i);
          //   formData.append('tanggal_tagihan_i', this.dataPerDokumen.tanggal_tagihan_i);
          //   // formData.append('file_tagihan_ii', this.dataPerDokumen.tagihan_ii);
          //   formData.append('tanggal_tagihan_ii', this.dataPerDokumen.tanggal_tagihan_ii);
          //   // formData.append('file_tagihan_iii', this.dataPerDokumen.tagihan_iii);
          //   formData.append('tanggal_tagihan_iii', this.dataPerDokumen.tanggal_tagihan_iii);
          // }

          axios.post(this.baseapi + 'api/permohonan_nonberusaha/uploadTagihan/' + this.dataPerDokumen.id, formData, {
            headers: {
              "Content-type": "application/json",
              Authorization: `Bearer ` + this.user.accessToken
            }
          })
            .then((res) => {
              this.$loading(false);
              this.$toasted.success(res.data.message);
              this.$refs.childBendahara.getdata()
              this.dataPerDokumen = []

              // Wait until the models are updated in the UI
              return res;
            })
            .catch((err) => {
              this.$loading(false);
              console.log(err)
              this.$toasted.error(err.response.data.message);
              // this.$bvModal.hide('modal-pembayaran')
              return err;
            });

        }
      })
    },

    loadProgress(id) {
      axios
        .get(
          this.baseapi +
          "api/status_permohonan_nonberusaha?filter=id_permohonan,=," +
          id,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.progressPermohonan = response.data.data;
          this.showModalTracking = true
          // this.$bvModal.show("modal-tracking");
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    async deleteDokumen(id) {
      Swal.fire({
        title: "Apa kamu yakin?",
        text: "Anda tidak akan dapat mengembalikan data ini!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya, hapus",
        cancelButtonText: "Tutup",
      }).then(async (result) => {
        if (result.isConfirmed) {
          axios
            .delete(this.baseapi + "api/permohonan_nonberusaha/" + id, {
              headers: {
                Authorization: `Bearer ` + this.user.accessToken,
              },
            })
            .then((response) => {
              Swal.fire("Berhasil", "" + response.data.message + "", "success");
              this.loaddata()
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },

    //Check Status Bayar
    async checkStatusBayar(data) {
      try {
        this.$loading(true);

        const payload = {
          kode_billing_simponi: this.getKodeBillingAktif(data),
          mode: "Nonberusaha", // Berusaha | Nonberusaha | Penambahan
          id_permohonan: data.id
        }

        const response = await this.$axios.post(
          this.baseapi + 'api/sync/passiveCheckSimponi',
          payload,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )

        console.log(response.data)

        if (response.data.success) {
          toast.success(this,
            'Status pembayaran berhasil diperbarui',
          )

          this.$refs.childAdmin.getdata();
          this.dataPerDokumen = [];
        } else {
          toast.warning(this,
            response.data.message || 'Status pembayaran tidak ditemukan',
            {
              title: 'Informasi',
              variant: 'warning',
              solid: true
            }
          )
        }

      } catch (error) {
        console.error(error)

        toast.error(this,
          error.response?.data?.message || 'Gagal cek status pembayaran',
          {
            title: 'Error',
            variant: 'danger',
            solid: true
          }
        )
      } finally {
        this.$loading(false);
      }
    },
    getKodeBillingAktif(data) {
      if (data.kode_billing_tagihan_iii) {
        return data.kode_billing_tagihan_iii
      }

      if (data.kode_billing_tagihan_ii) {
        return data.kode_billing_tagihan_ii
      }

      if (data.kode_billing_tagihan_i) {
        return data.kode_billing_tagihan_i
      }

      return null
    },

    initDatatable() {
      setTimeout(() => {
        var t = $("#tablepermohonan").DataTable({
          pagingType: "full_numbers",
          language: {
            info: "Menampilkan _START_ sampai _END_ dari _TOTAL_ data",
            paginate: {
              first: "Awal",
              last: "Akhir",
              next: "Selanjutnya",
              previous: "Sebelumnya",
            },
          },
          // order: [[0, 'desc']],
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true,
          fixedColumns: { left: 2, right: 1 },
          scrollX: true,
          dom: "Bfrtip",
          fnRowCallback: function (
            nRow,
            aData,
            iDisplayIndex,
            iDisplayIndexFull
          ) {
            //debugger;
            var index = iDisplayIndexFull + 1;
            $("td:first", nRow).html(index);
            return nRow;
          },
          columnDefs: [
            {
              targets: 0,
              render: function (data, type, row, meta) {
                // console.log(meta.row);
                // console.log(type == 'export' ? meta.row : data);
                return type == "export" ? meta.row + 1 : data;
              },
              rowCallback: function (row, data, index) {
                console.log(data);
                if (data[0] == "OK") {
                  $(row).addClass("green");
                } else if (data[0] == "Before") {
                  $(row).addClass("orange");
                }
              },
            },
          ],
          buttons: [
            // 'excel', 'pdf',
            // {
            //   text: '<i class="fa fa-plus"></i> Tambah',
            //   className: "btn btn-primary",
            //   action: function (e, dt, node, config) {
            //     localStorage.removeItem("id_permohonan");
            //     localStorage.setItem("tipe_pemohon", "Pemerintah");
            //     window.location = "/app/permohonan/form";
            //   },
            // },
            {
              extend: "excelHtml5",
              title: "DATA PEMOHON",
              text: '<i class="fa fa-file-text-o"></i> Excel',
              className: "btn text-white btn-success",
              exportOptions: {
                columns: [1, 2, 3, 4, 5, 6, 7, 8, 9],
                orthogonal: "export",
              },
              filename: function () {
                var today = new Date();
                // var n = d.getTime();
                var date =
                  today.getFullYear() +
                  "-" +
                  (today.getMonth() + 1) +
                  "-" +
                  today.getDate();

                return "Data Pemohon " + date;
              },
            },
          ],
        });

        t.on("order.dt search.dt", function () {
          t.column(0, { search: "applied", order: "applied" })
            .nodes()
            .each(function (cell, i) {
              cell.innerHTML = i + 1;
            });
        }).draw();
      }, 300);
    },
  },
};
</script>

<style src="./Elements.scss" lang="scss" />